<div class="container">
    <div class="card col-md-12">
        <div class="d-flex flex-row justify-content-end form-group mt-2 mb-5">
            <div>
                <button (click)="back()" class="btn btn-standard action-btn" type="button">
                    <i class="fa fa-arrow-left"></i> Back
                </button>
            </div>
        </div>
        <div class="card-title">
            <h2 class="orange-border">
                User Contact Details <i aria-label="User contact details tooltip"
                                        class="pi pi-question-circle tooltip-icon"
                                        pTooltip="Contact details entered will be used when sending out the user invitation."></i>
            </h2>
        </div>
        <div class="card-body">
            <form (ngSubmit)="onSubmit()" [formGroup]="form">
                <div class="row">
                    <div class="form-group col-md-8 col-lg-6">
                        <validation [formGroup]="form" controlName="email" displayName="User email">
                            <label for="email">Email:</label> <input [ngClass]="{'is-invalid': displayError(f.email)}"
                                                                     class="form-control"
                                                                     formControlName="email"
                                                                     id="email"
                                                                     pTooltip="User Email"
                                                                     type="text"/>
                            @if (isValidatingUserEmail) {
                                <div class="d-flex align-items-center">
                                    <output aria-hidden="true"
                                            class="spinner-border spinner-border-sm spinner-position  ml-auto"></output>
                                </div>
                            }
                        </validation>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-md-8 col-lg-6">
                        <validation [formGroup]="form" controlName="agentId" displayName="Agent ID">
                            <label for="agentId">Agent ID:</label>
                            <input [ngClass]="{'is-invalid': displayError(f.agentId)}"
                                   class="form-control"
                                   formControlName="agentId"
                                   id="agentId"
                                   maxlength="14"
                                   pTooltip="Unique agent identifier (10-14 alphanumeric characters)"
                                   placeholder="10-14 alphanumeric characters"
                                   type="text"/>
                        </validation>
                    </div>
                </div>

                <app-role-selector (outputRole)="onRoleSelect($event)"></app-role-selector>

                <div class="row">
                    <div class="col-md-12 text-center">
                        <button [disabled]="loading" class="navy-btn center">
                            Send <i [hidden]="!loading" class="fa fa-spinner fa-spin" style="font-size:15px"></i>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>